module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("fhg_title_and_download", [["div",{"class":"title"},[["span",{},[],[["title","__text",true]]]]],["if",{"notempty":""},[["div",{"class":"description"},[["span",{},[],[["description","__text",true]]]]]],[["description","notempty",true]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/freeHostedGallery.tpl
// module id = 1092
// module chunks = 4